<template>
  <div class="page-container">

    <div class="clause_title_area">
      <div class="clause_title">特星球用户协议</div>
    </div>

    <div class="clause_content_area">
      <div class="clause_content">
        <p>欢迎你使用特星球应用程序及服务。</p>
        <p>本用户许可协议以及本协议援引的其他法律条款(以下统称“协议”)是您与深圳市纽佰特信息科技有限公司(以下称“我们”或“特星球”)之间就您使用我们的特星球 APP 软件及相关服务(以下统称“软件”)所达成的具有法律效力的协议。</p>
        <p>本协议中，“您”指任何个人用户或单一法律实体。</p>
        <p>当您使用您的 TeslaID 登录使用软件前，请您务必审慎阅读、充分理解本协议(如 果您未满 16 周岁，或已满 16 周岁未满 18 周岁且不能以自己的劳动收入作为主要 收入来源的，请在法定监护人的陪同下阅读本协议)各项条款，特别是限制或免除 责任条款、隐私保护政策、法律适用和争议解决条款(包括管辖条款)，以及其它 以加粗加黑和/或加下划线等显示形式提示您注意的重要条款，请务必重点查阅。</p>
        <p>如您不同意这些条款，请不要下载、安装、访问或以任何方式使用本软件，也不要点击“我同意”“我接受”或其他类似表述。如您对本协议有任何的疑问、投诉、意见和建议，欢迎您通过本协议所附联系方式与我们沟通反馈，我们十分乐意为您解答。</p>
        <p>一.基础约定</p>
        <p>1.1 协议范围:考虑到互联网服务以及产品频繁迭代更新等行业特点，为了更全面 的界定您在注册和使用帐号的权利义务，本协议包括特星球根据法律法规规定以及本协议制定的其他政策、规则、公告声明等(除非特有所指，合称为“本协议”)，您也应当加以遵守。</p>
        <p>1.2 服务范围:特星球可以通过您的 TeslaID 帐号和密码登录特星球及特星球的关 联公司，第三方合作商将不断为您丰富的功能界面，包括但不限于移动应用程序 (“APP”)、PC 端、手机端、小程序以及其他形式。具体以特星球实时发布的服 务功能界面范围为准。</p>
        <p>1.3 修改与更新:特星球有权遵照法律法规规定，在必要时修改本协议(包括适时 制定并发布其他政策、规则、公告声明)，更新后的协议条款将代替原来的协议并在法律规定的期限届满后正式生效，您可以在相关服务页面查阅最新版本的协议条款。本协议修改后，如果您继续使用您的 TeslaID 帐号和密码登录特星球软件，即视为您已接受修改后的协议。如果您不接受修改后的协议，则您有权利停止登录使用特星球软件。</p>
        <p>1.4 帐号授予用户一项个人的、不可转让及免费使用(除本协议另有声明外)的许可，用户可以以非商业目的使用帐号。</p>
        <p>二.免责声明</p>
        <p>2.1 您理解并同意，“特星球 app”及相关服务可能会受多种因素的影响或干扰，公司不保证（包括但不限于）：</p>
        <p>2.1.1 公司完全适合用户的使用要求</p>
        <p>2.1.2 公司不受干扰，及时、安全、可靠或不出现错误；您经由公司取得的任何软件、服务或其他材料符合用户的期望</p>
        <p>2.1.3 软件中任何错误都将能得到更正</p>
        <p>2.2 对于涉嫌借款或其他涉财产的网络信息、账户密码、广告或推广等信息的，请您谨慎对待并自行进行判断，基干前述原因您因此遭受的利润、商业信誉、资料损失或其他有形或无形损失，公司不承担任何直接、间接、附带、特别、衍生性或惩罚性的赔偿责任</p>
        <p>2.3 您理解并同意，在使用“特星球 app”及相关服务过程中，可能遇到不可抗力等因素（不可抗力是指不能预见、不能克服井不能避免的客观事件），包括但不限于政府行为、自然灾害、网络原因、黑客攻击、战争或任何其它类似事件。出现不可抗力情况时，公司将努力在第一时间及时修复，但因不可抗力造成的损失，公司不承担责任</p>
        <p>2.4 公司依据本协议约定获得处理违法违规内容的权利，该权利不构成公司的义务或承诺，公司不能保证及时发现违法行为或进行相应处理</p>
        <p>2.5 您理解并同意，关王“特星球 app”及相关服务，公司不提供任何种类的明示或暗示担保或条任，包括但不限于商业适售性、特定用途适用性等。您对“特星球 app”及相关服务的使用行为必须自行承担相应风险</p>
        <p>2.6 您理解并同意．本协议是在保障遵守国家法律法规、维护公序良俗，保护他人合法权益，公司在能力范围内尽最大的努力按照相关法律法规进行判断，但并不保证公司判断完全与司法机关、行政机关的判断一致，如因此产生的后果您已经理解并同意自行承担</p>
        <p>2.7 在任何情況下，公司均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因您使用“特星球 app”及相关服务而遭受的利润损失，承担责任。公司对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您在成为特星球用户期间因使用“特星球 app”及相关服务而支付给公司的费用（如有）</p>
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'clause',
  components: {
  },
  data() {
    return {
      dataList: '',
      swiperOption: ''
    }
  },
  components: {
    // Swiper,
    // SwiperSlide
  },
  mounted() {
  },

  setup() {
  }
}
</script>

<style>

.clause_title_area {
  background-color: #424245;
  width: 100%;
  height: 32px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-top: 12px;
}

.clause_title {
  width: 100%;
  height: 32px;
  text-align: center;
  color: #E8E8ED;
  background-color: #424245;
  font-size: 25px;
}

.clause_content_area {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #424245;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.clause_content {
  width: 97%;
  height: 100%;
  background-color: #424245;
  text-align: left;
  color: #E8E8ED;
}


</style>
